import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import { Body2 } from "@xo-union/tk-ui-typography";
import { createTrackableProps, TrackablePropTypes } from "@xo-union/tk-component-analytics";
import styles from "./styles.css";
const SubNavLink = _ref => {
  let {
    active,
    classes: classesProp,
    href,
    children,
    trackableProps,
    ...props
  } = _ref;
  const classes = useClasses(styles, classesProp);
  const activeLinkStyle = active && classes.active;
  return /*#__PURE__*/React.createElement("li", {
    className: cx(classes['list-item'], activeLinkStyle)
  }, /*#__PURE__*/React.createElement(Body2, _extends({}, props, {
    as: "a",
    className: classes.link,
    href: href
  }, createTrackableProps(trackableProps)), children));
};
process.env.NODE_ENV !== "production" ? SubNavLink.propTypes = {
  /**
   * Force active state
   */
  active: PropTypes.bool,
  classes: classesPropType(),
  /**
   * Link href
   */
  href: PropTypes.string.isRequired,
  /**
   * Link text
   */
  children: PropTypes.node.isRequired,
  trackableProps: TrackablePropTypes.trackableProps
} : void 0;
export default SubNavLink;